import wixWindow from 'wix-window';

$w.onReady(function () {
    
    const repeater = $w('#webinarsrepeater');
    $w('#webinarsDataset').onReady(() => {
        const x = $w('#webinarsDataset').getItems(0, 12).then((info) => {

            repeater.data = info.items;

            repeater.forEachItem(($item, itemData) => {
                $item('#itemImage').src = itemData.thumbnail;
                $item('#itemImage').alt = itemData.thumbnailAltText;
                $item('#itemTitle').text = itemData.bigTitle.replace('.', '') + ' →';

                $item('#itemImage').onClick(() => {
                    wixWindow.openLightbox("Webinar Lightbox", {
                        smallTitle: itemData.smallTitle,
                        bigTitle: itemData.bigTitle,
                        description: itemData.description,
                        video: itemData.youtubeLink,
                    });
                });

            });
        })

    });
});
